import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@mui/material/Slide";

const style = {
  width: 300,
  "@media (min-width: 1636px)": {
    width: "28rem",
  },
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};
const UXAudio = new Audio();

const Confirmation = (props) => {
  const containerRef = React.useRef(null);
  const [timeoutObj, setTimeoutObj] = useState(null);
  const [initialRender, setInitialRender] = useState(true);

  const classes = useStyles();
  // Load Dynamic Image
  const loadImage = () => {
    switch (props.image) {
      case "assign":
       // return require("../../assets/main/assign_color.svg").default;
      case "delete":
        //return require("../../assets/delete.jpeg");
      case "error":
        if (
          props.primaryText &&
          props.primaryText.trim().toLowerCase() == "incorrect"
        ) {
          //UXEffect(require("../../assets/audio/incorrect.mp3"));
        } else {
          //UXEffect(require("../../assets/audio/error.mp3"));
        }
        //return require("../../assets/main/error.svg").default;
      case "thumb":
        //return require("../../assets/thumbs_up.png");
      case "complete":
       // UXEffect(require("../../assets/audio/congratulations.mp3"));
        //return require("../../assets/main/hands_up.svg").default;
    }
  };

  useEffect(() => {
    if (props.timeout && props.visible) {
      setTimeoutObj(
        setTimeout(() => {
          props.toggleModal(false);
        }, props.timeout)
      );
    }
    if (!props.visible && timeoutObj) {
      clearTimeout(timeoutObj);
    }
    if (!initialRender && !props.visible && props.onClose) {
      props.onClose();
    }
  }, [props.visible]);

  useEffect(() => {
    setInitialRender(false);
    return () => {
      UXAudio.pause();
      UXAudio.currentTime = 0;
    };
  }, []);

  const UXEffect = (src) => {
    if (!initialRender && props.visible && props.UX) {
      UXAudio.src = src;
      UXAudio.play();
    }
  };

  return (
    <div>
      <Modal
        open={props.visible}
        onClose={() => {
          if (!props.persistent) {
            props.toggleModal(false);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          border: "0px !important",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        ref={containerRef}
      >
        <Slide
          direction="up"
          in={props.visible}
          container={containerRef.current}
          timeout={250}
        >
          <Box
            sx={{
              ...style,
              backgroundColor: "#ff3838ff",
              border: 0,
              borderRadius: 6,
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                px: 4,
              }}
            >
              <Grid item sx={{ justifyContent: "center" }}>
                <Slide
                  direction="up"
                  timeout={500}
                  in={true}
                  mountOnEnter
                  unmountOnExit
                >
                  <img src={loadImage()} className={classes.image}></img>
                </Slide>
              </Grid>
              <Grid item>
                {props.primaryText && (
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "1.2rem",
                      fontWeight: "800",
                      textAlign: "center",
                      mt: 3,
                      "@media (min-width: 1636px)": {
                        fontSize: "2rem",
                      },
                    }}
                  >
                    {props.primaryText}
                  </Typography>
                )}
                {props.secondaryText && (
                  <Typography
                    id="modal-modal-title"
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "1rem",
                      fontWeight: "600",
                      textAlign: "center",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                  >
                    {props.secondaryText}
                  </Typography>
                )}
              </Grid>
              {!props.alert && (
                <>
                  {!props.confirmText && (
                    <>
                      <Grid item>
                        <Button
                          onClick={props.positiveClick}
                          variant="contained"
                          fullWidth
                          sx={{
                            borderRadius: 10,
                            backgroundColor: "#FFF",
                            color: "#ff3837",
                            fontWeight: "bold",
                            mt: 3,
                            px: 2,
                           
                            width: "15em",
                            "@media (min-width: 1636px)": {
                              width: "20rem",
                              fontSize: "1.4rem",
                            },
                          }}
                        >
                          {props.positiveText ? props.positiveText : "YES"}
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={props.negativeClick}
                          variant="contained"
                          fullWidth
                          sx={{
                            borderRadius: 10,
                            border: 1,
                            backgroundColor: "#FFF",
                            color: "#ff3837",
                            fontWeight: "bold",
                            mt: 2,
                            px: 2,
                            width: "15em",
                            "@media (min-width: 1636px)": {
                              width: "20rem",
                              fontSize: "1.4rem",
                            },
                          }}
                        >
                          {props.negativeText ? props.negativeText : "NO"}
                        </Button>
                      </Grid>
                    </>
                  )}
                  {props.confirmText && (
                    <Button
                      onClick={props.confirm}
                      variant="contained"
                      fullWidth
                      sx={{
                        borderRadius: 10,
                         backgroundColor: "#FFF",
                            color: "#ff3837",
                        fontWeight: "bold",
                       
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                        },
                        mt: 3,
                        px: 9,
                      }}
                    >
                      {props.confirmText}
                    </Button>
                  )}
                </>
              )}
            </Grid>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};
const useStyles = makeStyles({
  image: {
    width: "14rem",
    "@media (min-width: 1636px)": {
      width: "20rem",
    },
  },
});
export default Confirmation;
